import React, { useState } from 'react'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '~/lib/ui/collapsible'
import { Button } from '~/lib/ui/button'
import ResultsSection, { NotAvailable } from './ResultsSection'
import useTranslation from '../shared/TranslationProvider'

const JobTasksSection = ({ career, ...props }) => {
  const { tasks } = career
  const tasksToShow = tasks.slice(0, 5)
  const expandedTasks = tasks.slice(5)
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation('job_tasks')
  if (!tasks.length) {
    return <NotAvailable section="job_tasks" career={career} {...props} />
  }
  return (
    <ResultsSection section="job_tasks" career={career} {...props}>
      <ul className="list-disc pl-6">
        {tasksToShow.map((taskInfo, index) => (
          <li key={`task-${index}`}>{taskInfo['task']}</li>
        ))}
      </ul>
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        {!isOpen && (
          <CollapsibleTrigger asChild>
            <Button className="ml-6" variant="link">
              {t('show_more')}
            </Button>
          </CollapsibleTrigger>
        )}
        <CollapsibleContent>
          <ul className="list-disc pl-6">
            {expandedTasks.map((taskInfo, index) => (
              <li key={`task-${index}`}>{taskInfo['task']}</li>
            ))}
          </ul>
        </CollapsibleContent>
        {isOpen && (
          <CollapsibleTrigger asChild>
            <Button className="ml-6" variant="link">
              {t('show_less')}
            </Button>
          </CollapsibleTrigger>
        )}
      </Collapsible>
    </ResultsSection>
  )
}

export default JobTasksSection
